import axios from 'axios';
import store from '../store';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default {
  getPasswordStatus() {
    return apiClient.get('/account/password-status', {
      headers: { Authorization: `Bearer ${store.getters.token}` },
    });
  },
  changePassword(newPassword: string) {
    return apiClient.post(
      '/account/password',
      { newPassword },
      { headers: { Authorization: `Bearer ${store.getters.token}` } }
    );
  },
  getChangePasswordErrorMessage(error: any): string {
    const responseData = error?.response?.data;
    if (typeof responseData?.message === 'string' && responseData.message) {
      return responseData.message;
    }
    if (typeof responseData === 'string' && responseData) {
      return responseData;
    }

    return 'Unable to change password at this time. Please try again.';
  },
};
